export const SetUserInfo = info => ({ // eslint-disable-line import/prefer-default-export
  type: 'SET_USER_INFO',
  payload: { info },
});
